import React, {useState, useRef, useEffect} from 'react';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton';
import 'bootstrap/dist/css/bootstrap.css';
import Stats from './Stats';
import * as Actions from './attendee_actions';
import * as Options from './organizer_options';
import {useSessionReactions, useSessionInfo, useSessionState, useSessionColors} from './reusableHooks';


export default function Clicker({sessionId, thisUser, isAdmin, sessionChatOn, windowSize, radioValue, checkButton}) {
    const sessionInfo = useSessionInfo(sessionId);

    return (
      <>
        {((windowSize.width < 600 && radioValue==='1') || (windowSize.width >= 600)) && 
            <div id="clickerparent" key="clickerparent" className="shadow">
            {(sessionChatOn === 1 || sessionChatOn === 2)? <div key="clickerheader-sm" className="clickerheader-lg">{sessionInfo?.get("name")}</div> : <div key="clickerheader-lg" className="clickerheader-lg d-block">{sessionInfo?.get("name")}</div>}
            {(sessionChatOn === 1 || sessionChatOn === 2) && 
            <ToggleButtonGroup type="radio" name="toggleChat" defaultValue={1} aria-label="Toggle Chat Buttons" className="clickerheader-sm h-auto">
                <ToggleButton variant="secondary" id="radio-show-clicker" value={1} aria-label="Switch to clicker" className="mx-0 mt-0 clickerheader-sm left"
                onClick={(e) => (checkButton(e.target.value))}>
                Clicker
                </ToggleButton>
                <ToggleButton variant="secondary" id="radio-show-chat" value={2} aria-label="Switch to chat" className="mx-0 mt-0 clickerheader-sm right" 
                onClick={(e) => (checkButton(e.target.value))}>
                Chat
                </ToggleButton>
            </ToggleButtonGroup>
            }
            <Stats key="stats" sessionId={sessionId} isAdmin={isAdmin}/>
            <ReactionButtons sessionId={sessionId} thisUser={thisUser} isAdmin={isAdmin}/>
          </div>
          }
      </>
    )
  }

function ReactionButtons({sessionId, thisUser, isAdmin}) {
  const sessionReactions = useSessionReactions(sessionId, isAdmin);
  const buttonColors = useSessionColors(sessionId, false);
  //const buttonsDisabled = localStorage.getItem("buttons-disabled")? localStorage.getItem("buttons-disabled") : "active";
  const [disabled, setDisabled] = useState(false); //useState(buttonsDisabled);
  const mountedRef = useRef(false);
  const activeSession = useSessionState(sessionId);
  const [showError, setShowError] = useState(false);
  
  const handleOptionClick = (reaction, sessionId, uid) => {
    if(!isAdmin) {
      Actions.handleReactionClick(reaction, sessionId, uid).then((success) => {if(!success) alert("You're clicking too many times.")});
      //disableButtons();
    }
    else Options.handleTopicClick(reaction, sessionId, uid);
  }

  const disableButtons = () => {
    if(mountedRef.current) {
      localStorage.setItem("buttons-disabled", "disabled");
      setDisabled("disabled")
    }
  }

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    } 
  },[])

  useEffect(() => {
    /*if(mountedRef.current && disabled === "disabled" && activeSession && isAdmin === false) {
      setTimeout(function () {
        localStorage.setItem("buttons-disabled", "active");
        setDisabled("active")
      },500)
    }
    else */if(mountedRef.current && !activeSession) {
      disableButtons();
    }
  }, [disabled, activeSession])


  return (
    <div id="options" key="options" className={(!activeSession? "disabled" : "")} disabled={!activeSession} 
    data-tooltip="Thank you for participating in this test of new technology to share your thoughts on the proposed changes to Kendrick Park."> 
      {sessionReactions?.map(
        (reaction, index) => {
          return <div id={"reaction-" + (index+1)} key={"reaction-" + (index+1)} className={"optionbutton " + disabled} 
          onClick={() => {disabled !== "disabled" && handleOptionClick(reaction.toString(), sessionId, thisUser.uid)}}
          style={buttonColors && !isAdmin? {backgroundColor: buttonColors[index % buttonColors?.length]} : {}}
          >{reaction}</div>
      })}
    </div>
    /*<div id="options" key="options"> 
    {sessionReactions?.map(
      (reaction, index) => {
        return <div id={"reaction-" + (index+1)} key={"reaction-" + (index+1)} className="optionbutton" onClick={() => {handleOptionClick(reaction.toString(), sessionId, thisUser.uid)}}>{reaction}</div>
    })}
    </div>*/
  )
}
